import { FC, Fragment } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import AppLoading from "./AppLoading";

interface AppNotFoundProps {
    homeUrl?: string;
    loading?: boolean;
}
const AppNotFound: FC<AppNotFoundProps> = ({ homeUrl = "/", loading }) => {
    if (loading) {
        return <Fragment>
            <Helmet>
                <title>Vui lòng chờ...</title>
                <meta
                    name="CMS"
                    content="CMS"
                />
            </Helmet>
            <AppLoading />
        </Fragment>
    }
    return (
        <Fragment>
            <Helmet>
                <title>404 - Không tìm thấy trang</title>
                <meta
                    name="description"
                    content="Trang bạn tìm kiếm không tồn tại hoặc đã bị xóa."
                />
            </Helmet>

            <section className="flex items-center justify-center h-full">
                <div className="text-center p-8">
                    <div className="text-blue-600 text-9xl font-bold">404</div>
                    <div className="mt-4 mb-6">
                        <i className="fas fa-exclamation-triangle text-yellow-500 text-5xl"></i>
                    </div>
                    <h1 className="text-2xl font-semibold text-gray-800 mb-2">
                        Oops! Không tìm thấy trang
                    </h1>
                    <p className="text-gray-600 mb-6">
                        Trang bạn đang tìm kiếm có thể đã bị xóa, đổi tên hoặc tạm thời không khả dụng.
                    </p>
                    <Link
                        to={homeUrl}
                        className="inline-block bg-blue-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-blue-700 transition"
                    >
                        <i className="fas fa-home mr-2"></i> Quay về trang chủ
                    </Link>
                </div>
            </section>
        </Fragment>
    );
};

export default AppNotFound;